import { Container } from "react-bootstrap";
import Header from "./Header";
import Dashboard from "./Dashboard";
import { Outlet } from "react-router-dom";
import "./Layout.css";
import React, { useEffect, useState } from "react";

const Layout = ({ navigation: Navigation }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia("(max-width: 767.98px)");
    const syncCollapsed = () => setCollapsed(mediaQuery.matches);

    syncCollapsed();
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", syncCollapsed);
    } else {
      mediaQuery.addListener(syncCollapsed);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", syncCollapsed);
      } else {
        mediaQuery.removeListener(syncCollapsed);
      }
    };
  }, []);

  return (
    <>
      <Header />

      <Container fluid className="layout-container">
        <div className={`Layout ${collapsed ? "is-sidebar-collapsed" : "is-sidebar-open"}`}>
          <aside className="layout-sidebar">
            {Navigation ? <Navigation collapsed={collapsed} toggleSidebar={toggleSidebar} /> : <Dashboard collapsed={collapsed} toggleSidebar={toggleSidebar} />}
          </aside>

          <main className="layout-main">
            <Outlet context={{ toggleSidebar,collapsed }} />
          </main>
        </div>
      </Container>
    </>
  );
};

export default Layout;
